import React from 'react';
import VehicleLists from '../components/VehicleLists';

const ListOfVehicles = () => {
  return (
    <div>
      <VehicleLists />
    </div>
  );
};

export default ListOfVehicles;